export default "__VITE_ASSET__DHWueWAS__"